import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSubmit$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSubmit extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ac2fa65c3488448ce2dd2731d0e4724a09b1155a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4f07ce6a640dd63cf40f8d5826d6810cdb0da730', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '76719eccb471a0de81e08ebc22995b3fcef3d0f7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m-3.88 7.87L10 14.2a.49.49 0 0 0 .69-.03l4.7-5.58a.49.49 0 0 0-.06-.7l-.38-.32a.48.48 0 0 0-.7.06l-4 4.74-2.07-2.06a.5.5 0 0 0-.71 0l-.35.35a.5.5 0 0 0 0 .71", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-submit", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-submit"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-submit":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSubmit$1);
            }
            break;
    } });
}

const CosmosIconSubmit = CosmosIconSubmit$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSubmit, defineCustomElement };
